module.exports = __webpack_public_path__ + "static/img/kn-Goupa.1ff90dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kn-Goupa.jpg
// module id = /0NZ
// module chunks = 1